"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundRetrocedingCost = roundRetrocedingCost;
const big_js_1 = __importDefault(require("big.js"));
const round_cost_1 = require("./round-cost");
function roundRetrocedingCost(cost) {
    const roundedTotalCost = (0, round_cost_1.roundCost)(cost.totalCost);
    const roundedCostPerLine = roundCostPerLine(cost.costPerLine, roundedTotalCost);
    return {
        totalCost: roundedTotalCost,
        costPerLine: roundedCostPerLine
    };
}
function roundCostPerLine(costPerLine, roundedTotalCost) {
    const roundedCostPerLine = costPerLine.map(line => ({ ...line, cost: (0, round_cost_1.roundCost)(line.cost) }));
    const adjustedLastLine = adjustLastLine(roundedCostPerLine, roundedTotalCost);
    return roundedCostPerLine.slice(0, roundedCostPerLine.length - 1).concat([adjustedLastLine]);
}
function adjustLastLine(roundedCostPerLine, roundedTotalCost) {
    const lastLine = roundedCostPerLine[roundedCostPerLine.length - 1];
    const totalOfLines = roundedCostPerLine.reduce((total, line) => {
        return {
            withoutVAT: (0, big_js_1.default)(total.withoutVAT).add(line.cost.withoutVAT).toString(),
            withVAT: (0, big_js_1.default)(total.withVAT).add(line.cost.withVAT).toString(),
            vAT: (0, big_js_1.default)(total.vAT).add(line.cost.vAT).toString()
        };
    }, {
        withoutVAT: '0',
        withVAT: '0',
        vAT: '0'
    });
    return {
        ...lastLine,
        cost: {
            ...lastLine.cost,
            withoutVAT: (0, big_js_1.default)(roundedTotalCost.withoutVAT)
                .minus(totalOfLines.withoutVAT)
                .add(lastLine.cost.withoutVAT)
                .toFixed(round_cost_1.COST_PRECISION),
            withVAT: (0, big_js_1.default)(roundedTotalCost.withVAT)
                .minus(totalOfLines.withVAT)
                .add(lastLine.cost.withVAT)
                .toFixed(round_cost_1.COST_PRECISION),
            vAT: (0, big_js_1.default)(roundedTotalCost.vAT).minus(totalOfLines.vAT).add(lastLine.cost.vAT).toFixed(round_cost_1.COST_PRECISION)
        }
    };
}
